export default __webpack_public_path__ + "static/media/GUNI.e72bb6b8.svg";